import axios from 'axios'

const API_BASE_URL = process.env.VUE_APP_LARAVEL_API_URL || 'https://broman.garnet.id/api'

// Configure Axios Interceptors globally
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token && token !== 'session_active') {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
      if (window.location.pathname !== '/auth/login') {
        window.location.href = '/auth/login'
      }
    }
    return Promise.reject(error)
  }
)

export default {
  /**
   * Login pengguna ke API Backend Laravel
   * @param {Object} credentials { email, username, password }
   */
  async login(credentials) {
    try {
      const payload = {
        email: credentials.email || credentials.username,
        username: credentials.username || credentials.email,
        password: credentials.password
      }

      const response = await axios.post(`${API_BASE_URL}/login`, payload)
      const data = response.data

      let token = data.token || data.access_token || data.data?.token || data.data?.access_token
      let user = data.user || data.data?.user || (data.data && typeof data.data === 'object' ? data.data : null)

      if (!user) {
        user = {
          name: credentials.email ? credentials.email.split('@')[0] : 'User API',
          email: credentials.email || ''
        }
      }

      if (token) {
        localStorage.setItem('auth_token', token)
      } else {
        localStorage.setItem('auth_token', 'session_active')
      }

      localStorage.setItem('auth_user', JSON.stringify(user))

      return {
        success: true,
        user,
        token,
        message: data.message || 'Login berhasil'
      }
    } catch (error) {
      console.error('Login error:', error)
      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        'Gagal login. Silakan periksa kembali email/username dan password Anda.'
      return {
        success: false,
        message
      }
    }
  },

  /**
   * Logout pengguna & hapus session dari localStorage
   */
  async logout() {
    try {
      const token = localStorage.getItem('auth_token')
      if (token && token !== 'session_active') {
        await axios.post(`${API_BASE_URL}/logout`).catch(() => {})
      }
    } finally {
      localStorage.removeItem('auth_token')
      localStorage.removeItem('auth_user')
    }
  },

  /**
   * Cek status autentikasi pengguna
   */
  isAuthenticated() {
    return !!localStorage.getItem('auth_token')
  },

  /**
   * Ambil data profil pengguna yang sedang login
   */
  getUser() {
    try {
      const userStr = localStorage.getItem('auth_user')
      return userStr ? JSON.parse(userStr) : null
    } catch (e) {
      return null
    }
  },

  /**
   * Ambil token autentikasi
   */
  getToken() {
    return localStorage.getItem('auth_token')
  }
}
